import {
  MasterDataQcqShiftItem,
  MasterDataQcqShiftListResponse, Competences, PlanningGroupList
} from '@/types/service-response'
import { QcqShiftDetails } from '@/model/master-data/QcqShiftDetails'
import { QcqShiftCompetences } from '@/model/master-data/QcqShiftCompetences'
import { QcqShiftPlanningGroup } from '@/model/master-data/QcqShiftPlanningGroup'
import { ShiftBreak } from '@/model/master-data/ShiftBreak'
import moment from 'moment'

export class QcqShift {
  public constructor (
    readonly id: number | undefined,
    readonly code: string,
    readonly description: string,
    readonly start: string,
    readonly end: string,
    readonly budget: number,
    public color: string,
    public competences: Array<QcqShiftCompetences>,
    public planningGroupList: Array<QcqShiftPlanningGroup>,
    readonly isActive: boolean,
    readonly shiftBreakList: ShiftBreak[],
    readonly duration: string
  ) {}

  static createListFromResponse (data: MasterDataQcqShiftListResponse): Array<QcqShift> {

    const result: Array<QcqShift> = data.map((item: MasterDataQcqShiftItem) => {
      let start: string = item.Start.split(' ')[0]
      let end: string = item.Ende.split(' ')[0]

      let competences: Array<QcqShiftCompetences> = []
      item.Competences.forEach((i: Competences) => {
        competences.push(new QcqShiftCompetences(
          i.ShiftID,
          i.ShiftPLGID,
          i.ID,
          i.Competences,
          i.CompetencesDescription,
          i.BildungsgradID,
          i.BildungsgradDescription,
          i.BerufID,
          i.BerufDescription,
          i.FachrichtungID,
          i.FachrichtungDescription,
          i.DetailsID,
          i.DetailsDescription,
          i.Bemerkungen,
          i.Abteilungen,
          i.Planungruppe,
          i.Arbeit,
          i.ArbeitBezeichnungCode,
          i.Offset,
          undefined,
          i.Quality

      ))
      })

      let planningGroupData: Array<QcqShiftPlanningGroup> = []
      item.PlanungruppeList.forEach((i: PlanningGroupList) => {
        planningGroupData.push({
          shiftId: i.IDShif,
          planningGroupId: i.Schichten_PlanungsgruppeId,
          numberOfEmployees: i.Anzahl,
          comment: i.Bemerkungen,
          departments: i.Abteilungen,
          planningGroup: i.Planungruppe,
          departmentsDesignation: i.AbteilungenBezeichnung,
          planningGroupName: i.PlanungsgruppeName,
          offset: i.Offset
        })
      })

      const shift: QcqShiftDetails = {
        id: item.ID,
        code: item.Code,
        description: item.Bezeichnung,
        start: start,
        end: end,
        budget: item.Budget,
        color: item.Farbe,
        competences: competences,
        planningGroupList: planningGroupData
      }

      let shiftBreakList: ShiftBreak[] = ShiftBreak.createFromResponse(item.SchichtenPausenData)
      let duration: string = ''
      if(shift.start && shift.end) {
        let startDuration: number = (moment(shift.start, 'HH:mm').hour() * 60) + moment(shift.start, 'HH:mm').minutes()
        let endDuration: number = (moment(shift.end, 'HH:mm').hour() * 60) + moment(shift.end, 'HH:mm').minutes()
        let shiftDuration: number = endDuration - startDuration

        shiftBreakList.forEach((item: ShiftBreak) => {
          if(item.startBreak && item.endBreak) {
            let startDuration: number = (moment(item.startBreak, 'HH:mm').hour() * 60) + moment(item.startBreak, 'HH:mm').minutes()
            let endDuration: number = (moment(item.endBreak, 'HH:mm').hour() * 60) + moment(item.endBreak, 'HH:mm').minutes()
            let pauseDuration: number = endDuration - startDuration
            shiftDuration = shiftDuration - pauseDuration
          }
        })

        duration = moment.utc(shiftDuration *60 * 1000).format('HH:mm')
      }

      return new QcqShift(
        shift.id,
        shift.code,
        shift.description,
        shift.start,
        shift.end,
        shift.budget,
        shift.color,
        shift.competences,
        shift.planningGroupList,
        item.Aktiv,
        shiftBreakList,
        duration
      )
    })
    return result
  }
}
